import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cedfb2de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "container",
  class: "multi-select"
}
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = {
  key: 0,
  "data-testid-button-label": "",
  class: "multi-select-button-label"
}
const _hoisted_4 = {
  "data-testid-button-text": "",
  class: "multi-select-button-text"
}
const _hoisted_5 = { class: "is-flex is-align-items-center" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "fas fa-chevron-circle-right"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-chevron-circle-down"
}
const _hoisted_12 = ["placeholder", "aria-label"]
const _hoisted_13 = ["onClick", "onMouseenter", "onKeydown", "aria-selected", "tabindex"]
const _hoisted_14 = { class: "multi-select-list-option-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualScroller = _resolveComponent("VirtualScroller")!
  const _directive_tab_index = _resolveDirective("tab-index")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.buttonText != 'Teknik')
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          "data-testid-button": "",
          class: "multi-select-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open = !_ctx.open)),
          type: "button",
          "aria-expanded": _ctx.open
        }, [
          (_ctx.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.buttonText), 1),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.clearBtn && _ctx.value?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  "data-testid-clear": "",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.clear()), ["stop"])),
                  class: "btn multi-select-button-icon",
                  "aria-label": _ctx.$t('aria.global.close')
                }, _hoisted_8, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              "data-testid-chevron": "",
              tabindex: "-1",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.open = !_ctx.open), ["stop"])),
              class: "btn multi-select-button-icon",
              "aria-label": _ctx.open ? _ctx.$t('aria.global.collapse') : _ctx.$t('aria.global.expand')
            }, [
              (!_ctx.open)
                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                : (_openBlock(), _createElementBlock("i", _hoisted_11))
            ], 8, _hoisted_9)
          ])
        ], 8, _hoisted_2)), [
          [_directive_tab_index, !_ctx.hidden]
        ])
      : _createCommentVNode("", true),
    (_ctx.search)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          "data-testid-search": "",
          class: _normalizeClass([{ open: _ctx.open }, "multi-select-search"])
        }, [
          _withDirectives(_createElementVNode("input", {
            "data-testid-search-input": "",
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchValue) = $event)),
            placeholder: _ctx.$t('search.dots'),
            "aria-label": _ctx.$t('aria.global.search')
          }, null, 8, _hoisted_12), [
            [_vModelText, _ctx.searchValue]
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.getOptions.length)
      ? (_openBlock(), _createBlock(_component_VirtualScroller, {
          key: 2,
          class: _normalizeClass(["multi-select-list", [{ open: _ctx.open }, { search: _ctx.search }]]),
          items: _ctx.sortedOptions,
          active: _ctx.activeIndex,
          itemSize: 35,
          "aria-activedescendant": _ctx.activeOptionId(_ctx.activeIndex),
          role: "listbox",
          "aria-label": _ctx.placeholder
        }, {
          default: _withCtx(({ item, index }) => [
            (_openBlock(), _createElementBlock("button", {
              "data-testid-list-option": "",
              key: item.value,
              onClick: ($event: any) => (_ctx.onSelect(item.value)),
              class: _normalizeClass(["multi-select-list-option", [{ selected: _ctx.isSelected(item.value) }, { active: _ctx.activeIndex == index }]]),
              onMouseenter: ($event: any) => (_ctx.activeIndex = index),
              onKeydown: [
                _withKeys(_withModifiers(($event: any) => (_ctx.onSelect(item.value)), ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.onSelect(item.value)), ["prevent"]), ["space"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.navigateUp(index)), ["prevent"]), ["up"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.navigateDown(index)), ["prevent"]), ["down"])
              ],
              type: "button",
              role: "option",
              "aria-selected": _ctx.isSelected(item.value),
              tabindex: _ctx.activeIndex === index ? '0' : '0',
              ref: "optionButtons"
            }, [
              _createTextVNode(_toDisplayString(item.text) + " ", 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(item.hitCount !== undefined ? `(${item.hitCount})` : ""), 1)
            ], 42, _hoisted_13))
          ]),
          _: 1
        }, 8, ["class", "items", "active", "aria-activedescendant", "aria-label"]))
      : _createCommentVNode("", true)
  ], 512))
}